// export type BookCourtSection = {
//   id: BookCourtSectionEnum;
//   title: string;
//   isExpanded: boolean;
// };

// export enum BookCourtSectionEnum {
//   SELECT_DATE_TIME = 1,
//   SELECT_CIRCLE,
//   PAYMENT,
// }

// export type BookCourtData = {
//   sections: BookCourtSection[];
// };

export type CourtType = {
  id: CourtId;
  title: string;
};

export enum CourtId {
  Indoor = 1,
  Outdoor,
  Singles,
  IndoorLegacy,
}

export type Avatar = {
  image: string;
  name: string;
};

export type PlayerCircleGraph = {
  id: number;
  value: string;
};

export type UltraServiceLocationUrl = {
  id: number;
  url: string;
};

export type UltraServiceLocation = {
  id: number;
  name: string;
  isEnabled: boolean;
};
